import {OrderService, MovieService, RegionService, AuthService, EcomTrackingService} from 'hasta-la-vista-middleware-api/service'
import {Booking} from 'hasta-la-vista-middleware-api/model'
import {Utils} from 'hasta-la-vista-ui-core'
export default {
    data() {
        return {
            loading: true,
            booking: [],
            related_movies: [],
            movie: {},
            cinema: {},
            generateLoader: false,
            pdfUrl: "",
            facebookPixelWBShow: false,
            facebookPixelSKShow: false,
            facebookPixelSWShow: false,
        }
    },

    computed: {

        seatsString(){
            return this.booking.Tickets.map((t)=>t.SeatData).join(',');
        },

        bookingDate(){
            return `${this.booking.opening_date}`
        },
        movieStartTime(){
            return `${this.booking.opening_date}`
        },
        movieEndTime(){
            return 'TODO';
        }

    },
    methods: {

        downloadPDF() {
            // this.generateLoader = true;
            return OrderService.generateConfirmationPDF(this.$route.params.booking_number, this.$route.params.booking_id, this.$route.params.cinema_id)
            // this.generateLoader = false;
        },

        print(){
            window.print();
        },

        facebookPixelSK(thisMovie) {
          !function(f,b,e,v,n,t,s)
          {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
            n.callMethod.apply(n,arguments):n.queue.push(arguments)};
            if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
            n.queue=[];t=b.createElement(e);t.async=!0;
            t.src=v;s=b.getElementsByTagName(e)[0];
            s.parentNode.insertBefore(t,s)}(window, document,'script',
            'https://connect.facebook.net/en_US/fbevents.js');
          fbq('init', '1442556416455138');
          fbq('track', 'PageView');
            this.facebookPixelSKShow = true
        },

        facebookPixelWB(thisMovie) {
            //HO00001598 | HO00001579 | HO00001531
            if(thisMovie == "ANNA" || thisMovie == "IT: CHAPTER 2" || thisMovie == "JOKER") {
                !function(f,b,e,v,n,t,s)
                {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
                n.callMethod.apply(n,arguments):n.queue.push(arguments)};
                if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
                n.queue=[];t=b.createElement(e);t.async=!0;
                t.src=v;s=b.getElementsByTagName(e)[0];
                s.parentNode.insertBefore(t,s)}(window, document,'script',
                'https://connect.facebook.net/en_US/fbevents.js');
                fbq('init', '492438917984256');
                fbq('track', 'PageView');
                this.facebookPixelWBShow = true
            }
        },

        facebookPixelStarWars(thisMovie) {
            if(thisMovie == "STAR WARS: THE RISE OF SKYWALKER") {
                !function(f,b,e,v,n,t,s)
                {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
                n.callMethod.apply(n,arguments):n.queue.push(arguments)};
                if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
                n.queue=[];t=b.createElement(e);t.async=!0;
                t.src=v;s=b.getElementsByTagName(e)[0];
                s.parentNode.insertBefore(t,s)}(window, document,'script',
                'https://connect.facebook.net/en_US/fbevents.js');
                fbq('init', '482871855641247');
                fbq('track', 'PageView');
                this.facebookPixelSWShow = true
            }
        },
        adsrvrPixel() {
          ttd_dom_ready( function() {
            if (typeof TTDUniversalPixelApi === 'function') {
              var universalPixelApi = new TTDUniversalPixelApi();
              universalPixelApi.init("mxyqca6", ["ytaat3z"], "https://insight.adsrvr.org/track/up");
            }
          });
        }
    },
    created(){
        Promise.all([OrderService.getBooking(this.$route.params.booking_number, this.$route.params.booking_id, this.$route.params.cinema_id), MovieService.getMovies(), this.downloadPDF()]).then(([booking, movies, pdfUrl]) => {
            //console.log("booking", booking)
            Promise.resolve(EcomTrackingService.doSuccessfulTransaction(booking)).then((result) => {

            })
            this.pdfUrl = pdfUrl
            this.booking = booking;

            // console.log("booking",booking);

            for(let i = 0; i <= booking.length; i++) {
                if(booking[i] != undefined) {
                    this.facebookPixelWB(booking[i].MovieName)
                    // this.facebookPixelSK(booking[i].MovieName)
                    this.facebookPixelStarWars(booking[i].MovieName)
                }
            }

            this.facebookPixelSK()

            this.related_movies = movies.data;
            OrderService.commitGenreCount().then(
                ()=>this.loading = false
                , ()=>this.loading = false
            )
            //console.log("booking",booking)
            let fireEpicDealPixel = false
            if(booking[0] !== undefined) {
               if(booking[0].Tickets !== undefined) {
                  //console.log("booking data",booking)
                  for(let i = 0; i < booking[0].Tickets.length; i++) {
                      //console.log("ticket",booking[0].Tickets[i]);
                      if(booking[0].Tickets[i].Description.includes('Epic')) {
                         fireEpicDealPixel = true
                      }
                  }
               }
            }

            if(fireEpicDealPixel) {
              this.adsrvrPixel();
            }

            this.loading = false;
        }, (error) => {
            Promise.reject(error)
        });
    }
}



// WEBPACK FOOTER //
// ./src/components/booking/booking-successful/booking-successful.js